import React from 'react'
import { Link } from 'react-router-dom'
import styles from './styles.css'
import { usePathContext } from '../../PathContext'

const RatingContactPageMetadataFooter: React.SFC = () => {
  const pathContext = usePathContext()

  // This one has a special rendering treatment, just it's existence renders this
  const ratingWrapperMetaData = pathContext.pathFlowPage.metadata.find(
    metadata => metadata.__typename === 'RatingContactPageMetadata'
  )

  if (!ratingWrapperMetaData) {
    return null
  }

  return (
    <div className={styles.footer}>
      By submitting, you agree to receive text messages from Curated.com and agree to our{' '}
      <Link to="/legal/terms-conditions" className={styles.link} target="_blank">
        Terms of Use
      </Link>{' '}
      and{' '}
      <Link to="/legal/privacy-policy" className={styles.link} target="_blank">
        Privacy Policy
      </Link>
      . Message and data rates may apply. Turn off text alerts anytime by replying STOP.
    </div>
  )
}

export default RatingContactPageMetadataFooter
